import React, { ChangeEvent } from 'react';

import { Button, Dropdown, Input } from '@salvapp/ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import { DropdownOption } from '@salvapp/ui-components/build/dropdown/dropdown.types';
import { BridgeApiTemplateFieldTypeEnum } from '../api-internal';
import { RFISendingFormValues } from './NewRequestSidePanel';

const textTypeOption = {
  key: BridgeApiTemplateFieldTypeEnum.TEXT,
  value: BridgeApiTemplateFieldTypeEnum.TEXT,
  label: BridgeApiTemplateFieldTypeEnum.TEXT,
};

const numberTypeOption = {
  key: BridgeApiTemplateFieldTypeEnum.NUMBER,
  value: BridgeApiTemplateFieldTypeEnum.NUMBER,
  label: BridgeApiTemplateFieldTypeEnum.NUMBER,
};

const dateTypeOption = {
  key: BridgeApiTemplateFieldTypeEnum.DATE,
  value: BridgeApiTemplateFieldTypeEnum.DATE,
  label: BridgeApiTemplateFieldTypeEnum.DATE,
};

const fileTypeOption = {
  key: BridgeApiTemplateFieldTypeEnum.FILE,
  value: BridgeApiTemplateFieldTypeEnum.FILE,
  label: BridgeApiTemplateFieldTypeEnum.FILE,
};

const booleanTypeOption = {
  key: BridgeApiTemplateFieldTypeEnum.BOOLEAN,
  value: BridgeApiTemplateFieldTypeEnum.BOOLEAN,
  label: BridgeApiTemplateFieldTypeEnum.BOOLEAN,
};

const customFieldTypeOptions: DropdownOption[] = [
  textTypeOption,
  numberTypeOption,
  dateTypeOption,
  fileTypeOption,
  booleanTypeOption,
];

const CustomRequestedFieldsFormRow = ({
  values,
  setFieldValue,
}: {
  values: RFISendingFormValues;
  setFieldValue: (field: string, value: unknown) => void;
}): React.JSX.Element => {
  const addCustomField = () => {
    const newFieldName = 'field_' + uuidv4();
    const newFieldValue = {
      displayName: '',
      type: textTypeOption,
    };
    setFieldValue('custom.' + newFieldName, newFieldValue);
  };

  const removeCustomField = (fieldName: string) => {
    const newCustom = values.custom;
    delete newCustom[fieldName];
    setFieldValue('custom', newCustom);
  };
  return (
    <div className='request-for-custom'>
      {Object.entries(values.custom).map(([key], num) => (
        <div
          className='custom-requested-fields-row'
          style={{ display: 'flex', alignItems: 'flex-start', gap: '4px' }}
          key={num}
        >
          <div className='field-name'>
            <Input
              name={`custom.${key}.displayName`}
              inputSize='medium'
              placeholder='field name'
              value={values.custom[key].displayName}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                setFieldValue(`custom.${key}.displayName`, event.target.value);
              }}
            />
          </div>
          <div className='field-type'>
            <Dropdown
              size='medium'
              name='custom-field-type'
              value={values.custom[key].type}
              options={customFieldTypeOptions}
              onChange={(value: DropdownOption[]) => {
                setFieldValue('custom.' + key + '.type', value[0]);
              }}
            />
          </div>
          <div className='field-remove'>
            <Button
              size='medium'
              variant='outline-danger'
              data-testid='custom-field-remove'
              onClick={() => removeCustomField(key)}
            >
              Remove
            </Button>
          </div>
        </div>
      ))}
      <div className='add-custom-field'>
        <Button size='medium' variant='secondary' onClick={() => addCustomField()}>
          <FontAwesomeIcon icon={faPlus} size='lg' /> Add custom field
        </Button>
      </div>
    </div>
  );
};

export default CustomRequestedFieldsFormRow;
